import styled from 'styled-components'

import typeStyle from 'styles/typeStyle'

const MoreButton = styled.button`
  ${typeStyle('-ds-font-body-emphasised')}
  display: block;
  text-decoration: none !important;

  appearance: none;
  background: none;
  border: 0;
  border-radius: 0;
  outline: 0;

  color: ${({ theme }) => theme.brand.jungle};

  padding-left: 0;
  padding-top: 16px;
  margin-top: 8px;
`

export default MoreButton
